import { Group, Stack } from "@mantine/core"
import { BlurredOverlayWithModal, InfoBox, SectionHeader } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { SETTINGS_SCOPE } from "@tfg/types/constants/communication-studio.constant"
import { PermissionLevelEnum } from "@tfg/types/endpoints/subscriptionPlan"

import { SUPPORT_EMAIL } from "~/constants/email"
import { DesignStudioWrapper } from "~/pages/Brand/CommunicationStudio/DesignStudio/components/DesignStudioWrapper"
import { useOrganizationSubscriptionPlanPermissions } from "~/pages/Brand/CommunicationStudio/contexts/organizationSubscriptionPlanPermissions/useOrganizationSubscriptionPlanPermissions"
import { useProductSheetGroup } from "~/pages/Brand/CommunicationStudio/contexts/productSheetGroup/useProductSheetGroup"
import { useAuth } from "~/store/auth-context"

export const DesignStudio = () => {
  const { t } = useTranslation("communicationStudio")
  const { isAdmin } = useAuth()

  const { selectedProductSheetGroup } = useProductSheetGroup()
  const productSheetGroupId = selectedProductSheetGroup?.id
  const { permissions } = useOrganizationSubscriptionPlanPermissions()

  const isReadOnly =
    permissions?.[SETTINGS_SCOPE.DESIGN_CUSTOMISATION]?.level ===
      PermissionLevelEnum.READONLY && !isAdmin

  return (
    <Stack pos="relative" h="100%" gap="md">
      <SectionHeader
        title={t("tabs.design.header.title")}
        subtitle={t("tabs.design.header.subtitle")}
      />
      <Group h="70vh" gap="md" align="stretch">
        {isReadOnly && (
          <BlurredOverlayWithModal
            title={t("lockedFeatureOverlay.designStudio.title")}
            message={t("lockedFeatureOverlay.designStudio.message")}
            buttonText={t("lockedFeatureOverlay.designStudio.buttonText")}
            onButtonClick={() => {
              window.open(
                `mailto:${SUPPORT_EMAIL}?subject=Upgrade%20to%20PRO%20plan`,
                "_blank"
              )
            }}
          />
        )}
        {productSheetGroupId ? (
          <DesignStudioWrapper displaySettingsId={productSheetGroupId} />
        ) : (
          <InfoBox
            title={t("design.noProductSheetGroup.title")}
            message={t("design.noProductSheetGroup.message")}
            variant="error"
          />
        )}
      </Group>
    </Stack>
  )
}
